import axios from "axios";

export const trackPageView = ({
  pageName,
  objectType,
  objectPK,
  objectIdentifier,
  objectVersion,
  l1App,
  l2App,
}: {
  pageName: string;
  objectType: string;
  objectPK?: string;
  objectIdentifier?: string;
  objectVersion?: string;
  l1App?:
    | "Insights Hub"
    | "Insights Studio"
    | "Data Hub"
    | "Provider 360"
    | "Consumer 360"
    | "Insights Portal";
  l2App?:
    | "Cohort"
    | "Insights"
    | "Monitoring"
    | "Data Model"
    | "Orchestration"
    | "Integration"
    | "Transformation"
    | "Activity Stream"
    | "Attribution"
    | "Provider Directory"
    | "Configuration"
    | "Consumer Profile"
    | "Engagement"
    | "BI Workspace";
}): void => {
  axios
    .post("/monitoring/page_view", {
      page_name: pageName,
      url: window.location.href,
      object_type: objectType,
      object_pk: objectPK,
      object_identifier: objectIdentifier,
      object_version: objectVersion,
      l1_app: l1App,
      l2_app: l2App,
    })
    .catch((err) => console.error("Could not record page view", err));
};
